var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clock-loading"},[_c('div',{ref:"lottieIcon",staticClass:"lottie-icon"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.type == 1 ? '您的计划正在生成中…' : '正在启动该计划…'))])])}
var staticRenderFns = []

export { render, staticRenderFns }